import { Paper, withStyles } from '@material-ui/core';
import cn from 'classnames';
import React from 'react';

class HoverableCard extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            hovered: false
        }
    }

    render() {

        const { style, className, classes, children, ...props } = this.props

        return (
            <Paper
                {...props}
                onMouseEnter={() => this.setState({ hovered: true })}
                onMouseLeave={() => this.setState({ hovered: false })}
                className={
                    cn(
                        className,
                        classes.card,
                        'zoom-on-hover',
                        { [classes.sectionCardHovered]: this.state.hovered }
                    )
                }>
                {children}
            </Paper>
        )
    }

}

HoverableCard.propTypes = {

}

HoverableCard.defaultProps = {

}

const styles = theme => ({
    card: {
        padding: 16,
        boxShadow: 'none',
        transition: `all 300ms ${theme.transitions.easing.material}`,
        zIndex: 0,
        backgroundColor: 'transparent'
    },
    sectionCardHovered: {
        boxShadow: '0 24px 38px 3px rgba(0,0,0,0.035), 0 9px 46px 8px rgba(0,0,0,0.03), 0 11px 15px -7px rgba(0,0,0,0.05)',
        zIndex: 100,
        backgroundColor: '#FFFFFF'
    },
})

export default withStyles(styles)(HoverableCard)


// WEBPACK FOOTER //
// ./src/components/common/HoverableCard.js